import * as React from "react"
import { PageProps, Link, graphql } from "gatsby"

import Blog from "../components/blog"
import Seo from "../components/seo"

type DataProps = {
  site: {
    buildTime: string
  }
}

const Erpsekolah: React.FC<PageProps<DataProps>> = ({ data, path }) => (
  <Blog>
    <Seo title="Aplikasi ERP Sekolah" />
    <h1><strong><a href="/erpsekolah/">Aplikasi ERP Sekolah</a></strong></h1>
    <div className="embed-responsive embed-responsive-16by9 rounded">
<iframe width="560" height="315" src="https://www.youtube.com/embed/9X9rebrD4p4" title="Aplikasi ERP Sekolah"></iframe>
</div>
    <p>
    Siswa apps : homepage dashboard , jadwal mata pelajaran , list tugas dan ujian , download soal materi dari guru pengajar, hasil nilai dari tugas dan ujian, absensi list report , kalender agenda sekolah update dengan notif untuk pengumuman dan lain sebagai nya, status pembayaran siswa , website shortcut untuk akses website sekolah, dan log out keluar dari aplikasi.
    </p>
<p>Fitur : Master database untuk memasukan data akun kebutuhan akan pembayaran siswa di sekolah , daftar siswa untuk master data dalam pendataan siswa yang memudahkan nanti pada saat melakukan pembayaran keuangan , invoice fitur untuk menerbitkan tagihan pembayaran terkait keuangan sekolah , pembayaran menu untuk melakukan dan mencatat pembayaran siswa dan kebutuhan untuk sekolah , laporan untuk cek jumlah uang yang masuk di sekolah via pencatatan pembayaran.</p>
<div className="embed-responsive embed-responsive-16by9 rounded">
<iframe width="560" height="315" src="https://www.youtube.com/embed/KfLljbSdwho" title="Aplikasi ERP Sekolah"></iframe>
</div>
<p>
Database : Admin dengan kuasa penuh untuk melakukan regristasi hingga setting konfigurasi kebutuhan sekolah meliputi, database untuk regristasi kelas,ruang sekolah, bidang divisi staff dan guru , guru pengajar , tata usaha, orang tua wali , siswa, dan register pendaftaran siswa baru PPDB.
<br/>E-learn fungsi dan tugas elarn include guru pengajar apps login : pendaftaran kurikulum ajaran , tugas dan ujian soal pertanyaan folder bank , upload materi file soal tugas , kalusul level penilaian tugas dan ujian , hasil ujian dan tugas siswa , jadwal mata pelajaran , absensi siswa.
</p>
<div className="embed-responsive embed-responsive-16by9 rounded">
<iframe width="560" height="315" src="https://www.youtube.com/embed/t24CXOYOVOU" title="Aplikasi ERP Sekolah"></iframe>
</div>
<p>
Keuangan include divisi finance keuangan dan tata usaha apps meliputi pembuatan akun pembayaran sekolah, memasukan biaya kebutuhan untuk akun pembayaran , menerbitkan invoice pembayaran baik invoice tunggal maupun kolektif keseluruhan , laporan income keuangan sekolah .
<br/>Setting dan update : membuat agenda berita dan pengumuman via kalender otomatis untuk notifikasi ke masing masing login apps guru dan murid siswa , kelulusan dan migrasi kenaikan kelas dari kelas sebelumnya, serta website info untuk shortcut ke halaman admin panel website sekolah dalam kebutuhan update informasi dan berita pada website sekolah.
</p>
<p>Semakin mudah dengan dukungan APK android dalam bekerja untuk mobilitas pada aktivitas belajar mengajar</p>
<p>daftar harga layanan per tahun : 
<br/>Axcora school apps ,1.8GB Web Space , 1 Landing Page Website sekolah Rp.2.642.400 / years
<br/>Axcora school apps ,8GB Web Space , 1 CMS Website sekolah + web admin Rp.3.672.800 / years
<br/>Axcora school apps ,24GB Web Space , CMS Website sekolah + web admin Rp.5.812.600 / years.
<br/>Paket axcora school apps full e-learn system , Price tergantung dari kapasitas murid untuk online bersamaan.
<br/>kapasitas 50 user online bersamaan 2GB RAM / 10GB Storage Rp.6.854.700 / years
<br/>kapasitas 200 user 6GB RAM / 30GB Storage Rp.8.664.200 / years
<br/>kapasitas 500 user 12GB RAM / 60GB Storage Rp.16.718.500 / years
<br/>kapasitas 1000 user 24GB RAM / 120GB Storage Rp.26.105.300 / years
<br/>Paket full e-learn bonus 1 page desain website + 1 page web admin dan axcora school apps bonus domain .sch.id
</p>
<a href="https://wa.me/6285646104747" className="button col-12">Order Now</a>
<br/>    <Link to="/">Go back to the homepage</Link>
  </Blog>
)

export default Erpsekolah

export const query = graphql`
  {
    site {
      buildTime(formatString: "YYYY-MM-DD hh:mm a z")
    }
  }
`
